import axios from "axios";

const codeUrl = "/v2/api/codes";

class CodeService {
    // Search for all codes with optional query parameters
    static searchAllCodes(urlParams) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${codeUrl}${urlParams}`;
                const result = await axios.get(url);
                const pagingData = result.data;
                resolve(pagingData);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // Get a specific code by its ID
    static getCodeById(codeId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${codeUrl}/${codeId}`;
                const result = await axios.get(url);
                const codeData = result.data;
                resolve(codeData);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // Create a new code
    static createCode(codeData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = codeUrl;
                const result = await axios.post(url, codeData);
                const createdCode = result.data;
                resolve(createdCode);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // Update an existing code
    static updateCode(codeId, updatedCodeData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${codeUrl}/${codeId}`;
                await axios.put(url, updatedCodeData);
                resolve(`Code with ID ${codeId} updated successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // Delete a code by its ID
    static deleteCode(codeId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${codeUrl}/${codeId}`;
                await axios.delete(url);
                resolve(`Code with ID ${codeId} deleted successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // Create a code query for a specific code
    static createCodeQuery(codeId, codeQueryData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${codeUrl}/${codeId}/queries`;
                const result = await axios.post(url, codeQueryData);
                const createdCodeQuery = result.data;
                resolve(createdCodeQuery);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // Respond to an existing code query
    static respondToCodeQuery(codeId, queryId, responseData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${codeUrl}/${codeId}/queries/${queryId}`;
                await axios.put(url, responseData);
                resolve(`Code query with ID ${queryId} updated successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }
}

export default CodeService;
